import type { Board, Member } from '@trello/model-types';

import { getMemberTypeFromBoard } from './getMemberTypeFromBoard';
import type { MemberType } from './memberType.types';

export const isMemberTypeOfBoard = (
  member: Pick<
    Member,
    'id' | 'memberType' | 'idPremOrgsAdmin' | 'idEnterprisesAdmin'
  >,
  board: {
    memberships: Pick<
      Board['memberships'][number],
      'idMember' | 'memberType' | 'deactivated' | 'unconfirmed'
    >[];
    organization?:
      | (Pick<Board['organization'], 'id' | 'products'> & {
          memberships: Pick<
            Board['organization']['memberships'][number],
            'idMember' | 'memberType' | 'deactivated' | 'unconfirmed'
          >[];
          enterprise?: Pick<
            Board['organization']['enterprise'],
            'idAdmins'
          > | null;
        })
      | null;
  },
  memberType: MemberType,
  implicitAdmin = true,
) => {
  return getMemberTypeFromBoard(member, board, implicitAdmin) === memberType;
};
